import { FormSuggestionSource } from "@api/shared-runtime/enums";
import type { FormAnchorRef } from "@/features/hiring-process/form-anchor-ref";

/**
 * Suggestion-source priority sent with the form-fill suggestion queries:
 * array order IS the priority, and sources blend per field (each source only
 * fills fields every higher-priority one left empty). The order is owned by
 * the client so different fill contexts can rank sources differently.
 *
 * Profile first: canonical account data (name, email, phone, NPI, specialties,
 * licenses, professional type) outranks what the provider once typed into a
 * form; past submissions gap-fill the rest.
 *
 * Chat assignments were past-submissions-only while the profile source was
 * new. That exclusion stopped meaning what it looked like once the AI fallback
 * began running on every surface, because the fallback reasons from the same
 * profile data — an ad-hoc form was receiving profile-derived values anyway,
 * through a weaker path and under a different provenance tag.
 */
const DEFAULT_SOURCE_PRIORITY: FormSuggestionSource[] = [
  FormSuggestionSource.ProviderProfile,
  FormSuggestionSource.PastSubmissions,
];

/**
 * Every fill surface ranks sources the same way today. This stays the seam for
 * one that needs its own order.
 */
export function suggestionSourcesForAnchor(
  _anchor: FormAnchorRef,
): FormSuggestionSource[] {
  return DEFAULT_SOURCE_PRIORITY;
}
